angular.module("EICDataStream3.queryBuilder")
  .directive('queryBuilderRadio', [
    function() {
      return {
        restrict: 'E',
        priority: 10, // default is 0 (ie last)
        require: 'ngModel',
        template: "\
<label ng-click='toggleValue()'\
       ng-style='setStyle()'\
       style='wrap: nowrap;margin-bottom:0'>\
  <i  class='fa fa-lg'\
      ng-class='dotClass'\
      ng-style='setColour()'>\
   </i>\
  {{label}}\
</label>\
        ",
        scope:{
          state:      '=',
          value:      '=',
          name:       '=',
          label:      '='
        },
        link: function(scope, element, attrs, modelCtrl) {
          scope.name = attrs.name;

           var doRender = function() {
            // scope.isDotted is set to true or false depending on
            // which of the two possible symbols should be displayed
            scope.dotClass = (modelCtrl.$viewValue ==  scope.value) ? "fa-dot-circle-o"
                                                                    : "fa-circle-o";
           };

          modelCtrl.$render = doRender;

          scope.setStyle = function(){
            if(scope.state.isDisplaying){
              return {cursor:"default", "font-weight":"normal"};
            }
            else{
              return {cursor:"pointer", "font-weight":"bold"};
            }
          };

          scope.setColour = function(){
            if(scope.state.isDisplaying){
              return {color:"#555"};
            }
            else{
              return { color: "black" };
            }
          };

          scope.toggleValue=function(){
            if(scope.state.isDisplaying) return;

            modelCtrl.$setViewValue( scope.value  );
            doRender();
          };



        }
      }
    }
  ]);